const API_ENDPOINT = '?controller=appaction&action=';
const API_HOOK_ENDPOINT = '?controller=hook&action=';
const API_MODAL_ENDPOINT = '?controller=modal&action=';

export const STUDENT_ENDPOINT = `${API_ENDPOINT}student`;
export const INSTRUCTOR_ENDPOINT = `${API_ENDPOINT}instructor`;
export const LEGEND_ENDPOINT = `${API_ENDPOINT}legend`;
export const CALENDAR_ENDPOINT = `${API_ENDPOINT}calendar`;
export const LESSONS_HISTORY_ENDPOINT = `${API_ENDPOINT}history`;
export const RATE_HISTORY_ENDPOINT = `${API_ENDPOINT}rateHistory`;
export const STUDENTS_HISTORY_ENDPOINT = `${API_ENDPOINT}InformationOnStudents`;
export const RESERVE_LESSON_ENDPOINT = `${API_ENDPOINT}reservation`;
export const RESERVE_LESSON_BY_ADMIN_ENDPOINT = `${API_ENDPOINT}reservationadmin`;
export const REFUSE_LESSON_ENDPOINT = `${API_ENDPOINT}cancelreservation`;
export const REFUSE_LESSON_BY_ADMIN_ENDPOINT = `${API_ENDPOINT}cancelreservationstudent`;
export const BLOCK_LESSON_ENDPOINT = `${API_ENDPOINT}block`;
export const BLOCK_CASHING_ENDPOINT = `${API_ENDPOINT}blockcashing`;
export const UNBLOCK_CASHING_ENDPOINT = `${API_ENDPOINT}unblockcashing`;
export const CANCEL_EVENT_ENDPOINT = `${API_ENDPOINT}tocancelday`;
export const MODAL_UPDATE_RATING_ENDPOINT = `${API_ENDPOINT}updatefeedback`;
export const MODAL_QUALITY_RATING_ENDPOINT = `${API_HOOK_ENDPOINT}feedback`;
export const MODAL_SEND_QUALITY_RATING_ENDPOINT = `${API_HOOK_ENDPOINT}sendfeedback`;
export const MODAL_QUESTIONS_ENDPOINT = `${API_MODAL_ENDPOINT}questions`;
export const MODAL_SEND_QUESTIONS_ENDPOINT = `${API_MODAL_ENDPOINT}sendquestions`;
